import { render, staticRenderFns } from "./CourseGroup.vue?vue&type=template&id=c8303ee2"
import script from "./CourseGroup.vue?vue&type=script&lang=js"
export * from "./CourseGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports